module.exports = __webpack_public_path__ + "img/judge-m.6fe1ceaf.png";